import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from "@denishussar/html5-game-engine";
import { GameModel } from "../../Models/GameModel";

export interface ICharacterScreenPersonControllerOptions {
    onClick: () => void;
    frameLabel: string;
}

export class CharacterScreenPersonController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: ICharacterScreenPersonControllerOptions) {
        super("CharacterScreenPersonController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            onPointerDown: () => {
                if (this._options.onClick) {
                    this._options.onClick();
                }
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndStopByQuery('icon1', this._options.frameLabel);
    }
}

